import { usePantallaPago } from 'contexts/FormPagoContext';
import useQueryParams from 'hooks/useQueryParams';
import React from 'react';
import { MEDIOS_PAGO } from '../constants';
import CheckPagoOk from './CheckPagoOk';
import DetallePagoOnlineRealizado from './DetallePagoOnlineRealizado';
import DetallePagoReferenciadoRealizado from './DetallePagoReferenciadoRealizado';
import DetallePagoSuscripcionRealizado from './DetallePagoSuscripcionRealizado';

const DetallePagoRealizado = () => {
  const { codProducto } = useQueryParams();
  const { detallePago, medioPagoUsado, numeroPoliza, polizaCompletada, catalogo } = usePantallaPago();

  return (
    <div className="row justify-content-center mt-2">
      <div className="col-md-12 col-xl-11">
        <div className="row justify-content-center mt-5">
          <div className="col-md-6 text-center">
            <CheckPagoOk />
          </div>

          {medioPagoUsado === MEDIOS_PAGO.suscripcion && <DetallePagoSuscripcionRealizado />}

          {medioPagoUsado === MEDIOS_PAGO.pagoTradicional && (
            <DetallePagoReferenciadoRealizado codProducto={codProducto} />
          )}

          {medioPagoUsado === MEDIOS_PAGO.pago && <DetallePagoOnlineRealizado detallePago={detallePago} />}

          {polizaCompletada && (
            <div className="col-12 col-lg-11 text-center">
              <h5 className="font-mex font-20px">
                El proceso de contratación de tu póliza ha finalizado. En breve recibirás en el mail que registraste tu
                póliza.
              </h5>
              <h4 className="font-mex mt-2">Número de póliza</h4>
              <h5 className="font-mex mb-3">{numeroPoliza}</h5>
            </div>
          )}
          {catalogo.go4ItUrl && (
            <a
              href={catalogo.go4ItUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary-400 btn-wrap link-donwload"
              style={{ maxWidth: '25rem' }}
            >
              Consulta el reporte de opinión de valor de la vivienda
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetallePagoRealizado;
